import { render } from "./pb-pagecontactform.vue?vue&type=template&id=2fb9fa4b"
import script from "./pb-pagecontactform.vue?vue&type=script&lang=js"
export * from "./pb-pagecontactform.vue?vue&type=script&lang=js"

import "./pb-pagecontactform.vue?vue&type=style&index=0&id=2fb9fa4b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__